<template>
  <div class="article-just-to-nav">
    <h4 class="heading">Jump to</h4>
    <nav class="navigation">
      <Button
        v-for="item in items"
        :key="item.name"
        :transparent="true"
        tag="button"
        class="navigation__item"
        @click="scrollToItem(item.link)"
      >
        {{ item.name }}
      </Button>
    </nav>
  </div>
</template>

<script>
import Button from "@/components/Button.vue";
import { scrollIntoViewWithOffset } from "@/helpers/scroll.js";
export default {
  name: "ArticleJumpToNav",
  components: {
    Button,
  },
  props: {
    items: {
      type: Array,
      required: true,
    },
  },
  methods: {
    scrollToItem(link) {
      const element = document.querySelector(link);
      if (!element) {
        return;
      }
      scrollIntoViewWithOffset(element, 100);
    },
  },
};
</script>

<style lang="scss" scoped>
.article-just-to-nav {
  background: $color-white;
  display: grid;
  grid-template-columns: 1fr;
  padding-bottom: 40px;

  @include respond-above(md) {
    grid-template-columns: repeat(2, auto);
    padding: 20px 0 60px 20px;
  }
}

.heading {
  display: none;
  font-family: $heading-font-family;
  font-size: 30px;
  font-weight: normal;
  line-height: 1.5;
  text-transform: uppercase;

  @include respond-above(md) {
    display: block;
  }
}

.navigation {
  display: flex;
  gap: 20px;
  align-items: center;
  overflow-x: scroll;
  padding: 0 20px;
  white-space: nowrap;

  @include respond-above(md) {
    justify-content: right;
  }

  &__item {
    text-transform: uppercase;
    font-size: 10px;
    font-weight: 600;
    text-decoration: none;
    color: $color-grey-dark;
  }
}
</style>
